import { render, staticRenderFns } from "./UserRights.vue?vue&type=template&id=41193f95"
import script from "./UserRights.vue?vue&type=script&lang=js"
export * from "./UserRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports